import { PageHeader } from '@/ui'
import { RequestsQueue } from './RequestsQueue'

/** /redeem/requests: every app's code requests. */
export default function Requests() {
  return (
    <>
      <PageHeader title="요청" description="게시글에 달린 코드 요청. 한 사람은 앱당 한 장이다." />
      <RequestsQueue />
    </>
  )
}
